<template>
  <div
    :class="[
      'lg:grid lg:grid-flow-row lg:gap-8',
      'lg:grid-cols-' + amountSkeleton,
    ]"
  >
    <div
      v-for="(item, index) in !hasKiosk?amountSkeleton:amount"
      :key="index + Math.random()"
      :class="!hasKiosk&&'cursor-pointer w-full flex border-b-2 md:border-b-0 md:rounded-b-xl mx-4 pb-6 md:pb-0 pl-4 md:pl-0 transition duration-500 items-center justify-between rounded-t-lg flex-row md:flex-col' "
    >
      <MenuItemSkeleton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MenuItemSkeleton from "./MenuItemSkeleton.vue";
export default {
  data() {
    return {
      amountSkeleton: 0,
    };
  },
  props: {
    amount: {
      type: Number,
      default: screen.width > 1280 ? 3 : 2,
    },
  },
  components: {
    MenuItemSkeleton,
  },
  computed:{
    ...mapGetters(['hasKiosk']),
  },
  created() {
    window.innerWidth > 1280
      ? (this.amountSkeleton = 3)
      : (this.amountSkeleton = 2);
  },
};
</script>

<style lang="scss"></style>
